import React from "react";
import Icon, { type IconProps } from "./Icon";

const CompareColumnsIcon: React.FC<IconProps> = ({
  size = 24,
  color = "currentColor",
  ...props
}) => (
  <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 4h7v16H4V4zm9 0h7v16h-7V4z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);

export default CompareColumnsIcon;
